import axios from './config/axios'

const getStateRules = (state, groupNumber, selectedCoverages) => {
  return axios
    .get(
      `/api/rules/state-content/${state}`,
      {
        params: {
          groupNumber: groupNumber,
          coveragesAppliedFor: selectedCoverages.toString()
        },
        timeout: 180000
      })
    .then(r => r.data)
}
export default getStateRules